import React from 'react'
import LiveContent from '../../components/organisms/live-content/live-content'
import Layout from '../../shared/components/organisms/layout/layout'
import SEO from '../../shared/components/seo'
import useMobileMode from '../../shared/hooks/useMobileMode'
import './../../shared/_shared/Index.scss'

const EventTemplate = props => {
  const { isMobile, currentPage } = useMobileMode()
  const liveInfo = props.pageContext.content
  const seoImg = 'https:' + liveInfo?.imagenPrevisualizacion[0]?.file?.url

  return (
    <Layout title={liveInfo.metaTitulo} isMobile={isMobile} currentPage={currentPage}>
      <SEO
        title={liveInfo.metaTitulo}
        description={liveInfo.metaDescripcion.metaDescripcion}
        lang={props.pageContext.language}
        slug={'/academia-tena/lives/' + liveInfo.slug}
        image={seoImg}
      />
      <LiveContent liveInfo={liveInfo} isMobile={isMobile} />
    </Layout>
  )
}

export default EventTemplate
